// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-sent {
  display: flex;
  flex-direction: column;
  gap: calc(.5rem);

  text-align: center;
}

.reset-sent ftr-portal-badge {
    display: flex;
    justify-content: center;
  }

.reset-sent h1 {
    margin: calc(.5rem) 0 0 0;
  }

.reset-sent__link {
    display: block;
    -webkit-text-decoration: underline;
    text-decoration: underline;
    cursor: pointer;
  }

.reset-sent__email {
    font-weight: 700;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
